import React, { memo } from 'react';

import { InputWidth } from '../../types/InputWidth';
import { SharedDropdownProps } from '../../types/SharedDropdownProps';
import { Layout } from '../Layout/Layout';
import { Popover } from '../Popover/Popover';

export const Dropdown = memo(
  ({
    children,
    footer,
    header,
    isVisible,
    trigger,
    triggerMode,
    triggerWidth,
    onClickOutside,
    onHide,
    onShow,
  }: SharedDropdownProps) => {
    return (
      <Popover
        isVisible={isVisible}
        preset="dropdown"
        trigger={trigger}
        triggerStyle={componentStyles.trigger(triggerMode, triggerWidth)}
        containerStyle={componentStyles.container(triggerMode)}
        onClickOutside={onClickOutside}
        onHide={onHide}
        onShow={onShow}
      >
        <Layout direction="column" spacing={2} styles={componentStyles.base}>
          {header}
          {children}
          {footer}
        </Layout>
      </Popover>
    );
  },
);

export const componentStyles = {
  base: {
    minWidth: 'dropdown.min-width',
  },
  container: (mode: SharedDropdownProps['triggerMode']) => {
    switch (mode) {
      case 'shrink':
        return { minWidth: 0, display: 'flex' };
      default:
        return;
    }
  },
  trigger: (
    mode: SharedDropdownProps['triggerMode'],
    triggerWidth: InputWidth | undefined,
  ) => {
    switch (mode) {
      case 'triggerWidth':
        return { minWidth: 0, width: triggerWidth };
      default:
        return { minWidth: 0 };
    }
  },
};
